// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file jobs/v1/integration_event_job.proto (package jobs.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Environment } from "../../common/v1/environment_pb";
import { file_common_v1_environment } from "../../common/v1/environment_pb";
import type { EventData } from "../../integrations/v1/event_data_pb";
import { file_integrations_v1_event_data } from "../../integrations/v1/event_data_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file jobs/v1/integration_event_job.proto.
 */
export const file_jobs_v1_integration_event_job: GenFile = /*@__PURE__*/
  fileDesc("CiNqb2JzL3YxL2ludGVncmF0aW9uX2V2ZW50X2pvYi5wcm90bxIHam9icy52MSKGAQoTSW50ZWdyYXRpb25FdmVudEpvYhISCgpwcm9qZWN0X2lkGAEgASgJEisKC2Vudmlyb25tZW50GAIgASgOMhYuY29tbW9uLnYxLkVudmlyb25tZW50Ei4KCmV2ZW50X2RhdGEYAyABKAsyGi5pbnRlZ3JhdGlvbnMudjEuRXZlbnREYXRhQkpaSGdpdGh1Yi5jb20vZW1tZW1zL3N1cGVyLWNhcnQvYXBwcy9zcnYtd29ya2VyL3V0aWxzL21vZGVscy9qb2JzL3YxO2pvYnN2MWIGcHJvdG8z", [file_common_v1_environment, file_integrations_v1_event_data]);

/**
 * @generated from message jobs.v1.IntegrationEventJob
 */
export type IntegrationEventJob = Message<"jobs.v1.IntegrationEventJob"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: common.v1.Environment environment = 2;
   */
  environment: Environment;

  /**
   * @generated from field: integrations.v1.EventData event_data = 3;
   */
  eventData?: EventData;
};

/**
 * Describes the message jobs.v1.IntegrationEventJob.
 * Use `create(IntegrationEventJobSchema)` to create a new message.
 */
export const IntegrationEventJobSchema: GenMessage<IntegrationEventJob> = /*@__PURE__*/
  messageDesc(file_jobs_v1_integration_event_job, 0);

